import { TimeOperation } from "./TimeOperation";

export class SetTimeouService
{
    private last_date: Date = new Date();
    private last_index: number = 0;
    private onCalled(milliseconds: number)
    {
        this.last_index++;
        let l = TimeOperation.millisecondsLater(milliseconds - 1, new Date());
        if (this.last_date < l)
            this.last_date = l;
        return this.last_index;
    }
    setTimeoutIfNotCalledAgain(callback: () => void, milliseconds: number)
    {
        let index = this.onCalled(milliseconds);
        setTimeout(() =>
        {
            console.log({ index, last_index: this.last_index });
            if (index === this.last_index)
                callback();
        }, milliseconds);
    }
    setTimeoutIfFarArrival(callback: () => void, milliseconds: number)
    {
        this.onCalled(milliseconds);
        setTimeout(() =>
        {
            if (this.last_date < new Date())
                callback();
        }, milliseconds);
    }
}